export const MAIN_NAV_TEST_ID = "MAIN_NAV_TEST_ID";
export const PROFILE_NAV_TEST_ID = "PROFILE_NAV_TEST_ID";
export const MOBILE_MENU_PROFILE = "MOBILE_MENU_PROFILE";
export const OPEN_MOBILE_MENU_PROFILE_BUTTON =
  "OPEN_MOBILE_MENU_PROFILE_BUTTON";
export const MOBILE_MENU_MAIN = "MOBILE_MENU_MAIN";
export const OPEN_MOBILE_MENU_MAIN_BUTTON = "OPEN_MOBILE_MENU_MAIN_BUTTON";
